/**
 * Created by tomere on 7/1/2017.
 */

/**
 * This is a safe wrapper for $interval.
 *  It also destroys the interval when consuming scope is destroyed
 */
export default class IntervalService {
	constructor($interval) {
		this.$interval = $interval;
	}

	setInterval(intervalTime, scope, callBack) {
		this.killInterval();
		this.refreshInterval = this.$interval(() => {
			callBack();
		}, intervalTime);
		scope.$on('$destroy', () => {
			this.killInterval();
		});
	}

	killInterval() {
		if (angular.isDefined(this.refreshInterval)) {
			this.$interval.cancel(this.refreshInterval);
			this.refreshInterval = undefined;
		}
	}
}

IntervalService.META = {
	name: 'IntervalService'
};
IntervalService.$inject = ['$interval'];






// WEBPACK FOOTER //
// ./modules/distribution/services/interval.service.js